/** Default service options when garage onboarding list is empty */
export const DEFAULT_GARAGE_SERVICES = [
  'General Service',
  'Oil Change',
  'Brakes',
  'AC Service',
  'Engine',
  'Clutch',
  'Electrical',
  'Suspension',
  'Periodic Service',
  'Detailing'
];

export const GARAGE_DEAL_CITIES = [
  'Gurugram',
  'Delhi',
  'New Delhi',
  'Noida',
  'Faridabad',
  'Ghaziabad',
  'Mumbai',
  'Pune',
  'Bengaluru',
  'Hyderabad',
  'Chennai',
  'Kolkata',
  'Jaipur',
  'Ahmedabad',
  'Chandigarh'
];

export function parseGarageServicesFromDetails(garageDetails) {
  const raw = garageDetails?.services;
  if (Array.isArray(raw)) {
    return raw.map((s) => String(s || '').trim()).filter(Boolean);
  }
  if (typeof raw === 'string' && raw.trim()) {
    return raw
      .split(/[\n,;|•]+/)
      .map((s) => s.replace(/^[\s\p{Emoji_Presentation}\p{Extended_Pictographic}]+/u, '').trim())
      .filter(Boolean);
  }
  return [];
}

/**
 * Services the garage registered on profile — no platform default list mixed in.
 */
export function getGarageRegisteredServices(garageDetails) {
  const parsed = parseGarageServicesFromDetails(garageDetails);
  const seen = new Set();
  const out = [];
  for (const s of parsed) {
    const key = String(s || '').trim().toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(String(s).trim());
  }
  return out.sort((a, b) => a.localeCompare(b));
}

/** @deprecated Use getGarageRegisteredServices — defaults are no longer merged for deal forms */
export function mergeGarageServiceOptions(garageDetails) {
  return getGarageRegisteredServices(garageDetails);
}
